import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import GraphExercise from "./graphsExercise";

const GraphModal = ({
  isOpen,
  closeModal,
  exerciseData,
  exerciseName,
  stage,
}) => {
  if (!isOpen) return null;
  const getDynamicTitle = () => {
    if (!exerciseName) return "";

    if (stage === "10") {
      return `${exerciseName} – 10 Yard Split`;
    } else if (stage === "20") {
      return `${exerciseName} – 20 Yard Split`;
    }

    return exerciseName;
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
      <div className="bg-white rounded-lg shadow-lg z-50 max-w-screen-lg w-full p-6">
        <h2 className="text-xl font-bold text-center">{getDynamicTitle()}</h2>
        {exerciseData.length > 0 ? (
          <GraphExercise
            exerciseData={exerciseData}
            exerciseName={exerciseName}
          />
        ) : (
          <div className="flex items-center justify-center text-gray-500">
            <FontAwesomeIcon icon={faChartLine} className="text-3xl mr-2" />
            <span>There is no data to graph</span>
          </div>
        )}

        <div className="flex justify-center mt-4">
          <button
            className="bg-red-500 text-white px-4 py-2 rounded"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GraphModal;
